import React, { forwardRef, useImperativeHandle, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const Recaptcha = forwardRef(({ onVerify }, ref) => {
  const recaptchaRef = useRef();

  useImperativeHandle(ref, () => ({
    reset: () => {
      recaptchaRef.current?.reset();
    },
  }));

  const captchaValueChange = (value) => {
    onVerify(value);
  };

  const SITE_KEY = "6LetQF8rAAAAAEwgBvncJyEFB7lsowIMB2U6-QRc";

  return (
    <div>
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={SITE_KEY}
        onChange={captchaValueChange}
      />
    </div>
  );
});

export default Recaptcha;
